import CONVERSATION_DARK from './conversation-dark.webp'
import CONVERASTION_lIGHT from './conversation-light.jpg'

const CONVERSATION_BG = {
    DARK: CONVERSATION_DARK,
    LIGHT: CONVERASTION_lIGHT,
}

export default CONVERSATION_BG
